/**
 * Returns column definitions for dynamic search filter
 * Each column should have at minimum: { field, type? }
 * type: 'number' for numeric fields, undefined for string fields
 */
export const getColumns = () => {
  return [
    { field: 'ma_unit', type: 'string' }, // string
    { field: 'ngay_ct', type: 'string' }, // date/string
    { field: 'so_ct', type: 'string' }, // string
    { field: 'ngay_ct0', type: 'string' }, // date/string
    { field: 'so_ct0', type: 'string' }, // string
    { field: 'tk', type: 'string' }, // string
    { field: 'tk_du', type: 'string' }, // string
    { field: 'dien_giai', type: 'string' }, // string
    { field: 'ps_no', type: 'number' }, // number
    { field: 'ps_co', type: 'number' }, // number
    { field: 'ma_ct', type: 'string' } // string
  ];
};
